import { Flex } from "antd";
import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CRUISE_CATEGORY } from "../../../utils/helpers";
import Legends from "../v2/Legends";
import PromoTagRibbon from "../PromoTagRibbon";
import DepartureAirline from "../DepartureAirline";
import {mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import Icon from "@mdi/react";

dayjs.extend(customParseFormat);

const TourDateSelectorV3 = (props: {
  dates: any[];
  selectedDate: string;
  selectedTourCode: any;
  selectTour: Function;
  category: string;
  isNew?: boolean;
  isLoading?: boolean;
  open?: boolean;
  isMobile?: boolean;
}) => {
  const { dates, selectedDate, selectedTourCode, selectTour, category, isLoading, open, isMobile } = props;
  console.log(isMobile)
  const isCruise = category === CRUISE_CATEGORY;
  const hasAnyGD = !isCruise && dates.some(t => t.type === "guaranteed");
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const [isAtStart, setIsAtStart] = useState(false);
  const handleNextPreviousBtn = (isNext: boolean) => {
    if (!scrollRef.current) return;
  
    const container = scrollRef.current;
    const scrollAmount = container.clientWidth - 50;
  
    container.scrollBy({
      left: isNext ? scrollAmount : -scrollAmount,
      behavior: "smooth",
    });
  };
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 2;
    const atStart = container.scrollLeft + container.clientWidth <= container.clientWidth;
    setIsAtEnd(atEnd);
    setIsAtStart(atStart);
  };
  useEffect(() => {
    if (!scrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    setIsAtEnd(scrollLeft + clientWidth >= scrollWidth - 5 || scrollWidth === clientWidth);
    setIsAtStart(scrollLeft + clientWidth <= scrollWidth);
  }, [dates]);
  useEffect(() => {
    if (!scrollRef.current || !dates.length) return;
  
    scrollRef.current.scrollLeft = 0;
    if(scrollRef.current.scrollWidth !== scrollRef.current.clientWidth) setIsAtEnd(false);
  }, [dates]);

  useEffect(() => {
    // `open` is only meaningful for drawer usage (BookingFormV3) — skip only
    // when a drawer explicitly says it's closed. Inline usage (ShowPage) never
    // passes `open`, so it always scrolls the selected/resolved date into view.
    if (open === false || !scrollRef.current) return;
    const idx = dates.findIndex(t =>
      selectedDate ? (t.date === selectedDate && t.code === selectedTourCode) : t.code === selectedTourCode
    );
    const el = scrollRef.current.children[idx] as HTMLElement | undefined;
    if (el) el.scrollIntoView({ behavior: "auto", inline: "start", block: "nearest" });
  }, [open, selectedTourCode, selectedDate, dates.length]);

  return (
    <Flex gap={15} vertical className={`tour-date-selector v3${isAtEnd ? " at-end" : ""}${isAtStart ? " at-start" : ""}`}>
      <div className={`tour-date-selector-container${isAtEnd ? " at-end" : ""}${isAtStart ? " at-start" : ""}`}>
        {!isMobile && !isAtStart && (
          <button
            type="button"
            className="tour-date-btn-previous"
            onClick={()=>handleNextPreviousBtn(false)}
            aria-label="Previous departure dates"
          >
            <Icon className="tour-date-btn-previous_icon" path={mdiChevronLeft}/>
          </button>
        )}
        {/* Native CSS scroll-snap row — no react-slick (avoids fractional-slidesToShow ghost-scroll) */}
        <div className={`wrapper${isLoading ? " is-loading" : ""}`} ref={scrollRef} onScroll={handleScroll}>
          {dates.map((tour: { id?: number; date: string; code: string; type: string; price: string; indicator: string; promoTag?: string; airlineName?: string; airlineLogo?: string; saveAmount?: string, oldPrice?:string}) => {
              const tourDate = dayjs(tour.date, "DD/MM/YYYY").toDate();
              const tourYear = tourDate.getFullYear();
              const tourDateFormatted = dayjs(tourDate).format("DD MMM");
              const selected = selectedDate
                ? selectedDate === tour.date && selectedTourCode === tour.code
                : selectedTourCode === tour.code;

            return (
              <div key={tour.code} className={`tour-date-box-wrapper${tour.promoTag ? " has-promo" : ""}`} onClick={() => selectTour(tour)}>
                {hasAnyGD && (
                  <div
                    className="tour-date-box_gd-badge"
                    style={tour.type !== "guaranteed" ? { visibility: "hidden" } : undefined}
                  >
                    Guaranteed Departure
                  </div>
                )}
                <div className={`tour-date-box ${!isCruise ? tour.type : ""} ${selected ? "selected" : ""}`}>
                  {isMobile ? (
                    <><div className="tour-date-box_head">
                      <div className="tour-date-box_date">
                        <span>{tourYear}</span>
                        <b>{tourDateFormatted}</b>
                      </div>
                      <DepartureAirline name={tour.airlineName} logo={tour.airlineLogo} />
                    </div>
                    <div className="tour-date-box_divider" />
                    <div className="tour-date-box_pricing">
                      <span>From</span>
                      <div className="tour-date-box_price">{tour.price}</div>
                    </div>
                  </>
                  ) : (
                    <Flex justify="space-between" align="center" vertical gap={8} className="tour-date-box_content">
                      {(!isMobile && tour.airlineLogo) && <div className="tour-date-box_airline">
                          <img src={tour.airlineLogo} alt={tour.airlineName} onError={(e) => {
                            e.currentTarget.style.maxWidth = 'none';
                            e.currentTarget.style.width = 'auto';
                          }} />
                      </div>}
                      <div className="tour-date-box_date">
                        <span>{tourYear}</span>
                        <b>{tourDateFormatted}</b>
                      </div>
                      <div className="tour-date-box_other">
                        <span>From</span>
                        {(tour.saveAmount && tour?.saveAmount !=  "RM 0.00" && tour.oldPrice && tour?.oldPrice !=  "RM 0.00") && 
                          <div className="tour-date-box_old-price">{tour.oldPrice}</div>
                        }
                        <div className="tour-date-box_price">{tour.price}</div>
                        {(tour.saveAmount && tour?.saveAmount !=  "RM 0.00") && 
                          <div className="tour-date_save-amount">Saved {tour.saveAmount}</div>
                        }
                      </div>
                    </Flex>
                  )}
                  {tour.promoTag && <PromoTagRibbon label={tour.promoTag} />}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {!isCruise && <Legends />}
    </Flex>
  );
};

export default TourDateSelectorV3;
